module.exports = __webpack_public_path__ + "files/1492f37b1262728bdfd81198f7d4b5ea.png";